import './Cards.svelte.css';
/* src/components/Cards.svelte generated by Svelte v3.38.2 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { getDiff } from "../../_snowpack/pkg/json-schema-changelog.js";
import Card from "./Card.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (22:4) {:else}
function create_else_block_2(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "-- no additions --";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (16:4) {#if additions && additions.size}
function create_if_block_2(ctx) {
	let section;
	let current;
	let each_value_2 = Array.from(/*additions*/ ctx[0].values());
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			section = element("section");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(section, "class", "cards svelte-5tv68u");
		},
		m(target, anchor) {
			insert(target, section, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(section, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*Array, additions*/ 1) {
				each_value_2 = Array.from(/*additions*/ ctx[0].values());
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_2(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(section, null);
					}
				}

				group_outros();

				for (i = each_value_2.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_2.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (18:8) {#each Array.from(additions.values()) as diff}
function create_each_block_2(ctx) {
	let card;
	let current;
	card = new Card({ props: { diff: /*diff*/ ctx[5] } });

	return {
		c() {
			create_component(card.$$.fragment);
		},
		m(target, anchor) {
			mount_component(card, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(card.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(card.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(card, detaching);
		}
	};
}

// (34:4) {:else}
function create_else_block_1(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "-- no removals --";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (28:4) {#if removals && removals.size}
function create_if_block_1(ctx) {
	let section;
	let current;
	let each_value_1 = Array.from(/*removals*/ ctx[1].values());
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			section = element("section");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(section, "class", "cards svelte-5tv68u");
		},
		m(target, anchor) {
			insert(target, section, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(section, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*Array, removals*/ 2) {
				each_value_1 = Array.from(/*removals*/ ctx[1].values());
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(section, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (30:8) {#each Array.from(removals.values()) as diff}
function create_each_block_1(ctx) {
	let card;
	let current;
	card = new Card({ props: { diff: /*diff*/ ctx[5] } });

	return {
		c() {
			create_component(card.$$.fragment);
		},
		m(target, anchor) {
			mount_component(card, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(card.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(card.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(card, detaching);
		}
	};
}

// (46:4) {:else}
function create_else_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "-- no changes --";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (40:4) {#if changes && changes.size}
function create_if_block(ctx) {
	let section;
	let current;
	let each_value = Array.from(/*changes*/ ctx[2].values());
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			section = element("section");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(section, "class", "cards svelte-5tv68u");
		},
		m(target, anchor) {
			insert(target, section, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(section, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*Array, changes*/ 4) {
				each_value = Array.from(/*changes*/ ctx[2].values());
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(section, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (42:8) {#each Array.from(changes.values()) as diff}
function create_each_block(ctx) {
	let card;
	let current;
	card = new Card({ props: { diff: /*diff*/ ctx[5] } });

	return {
		c() {
			create_component(card.$$.fragment);
		},
		m(target, anchor) {
			mount_component(card, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(card.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(card.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(card, detaching);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let div0;
	let h20;
	let t1;
	let current_block_type_index;
	let if_block0;
	let t2;
	let div1;
	let h21;
	let t4;
	let current_block_type_index_1;
	let if_block1;
	let t5;
	let div2;
	let h22;
	let t7;
	let current_block_type_index_2;
	let if_block2;
	let current;
	const if_block_creators = [create_if_block_2, create_else_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*additions*/ ctx[0] && /*additions*/ ctx[0].size) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const if_block_creators_1 = [create_if_block_1, create_else_block_1];
	const if_blocks_1 = [];

	function select_block_type_1(ctx, dirty) {
		if (/*removals*/ ctx[1] && /*removals*/ ctx[1].size) return 0;
		return 1;
	}

	current_block_type_index_1 = select_block_type_1(ctx, -1);
	if_block1 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
	const if_block_creators_2 = [create_if_block, create_else_block];
	const if_blocks_2 = [];

	function select_block_type_2(ctx, dirty) {
		if (/*changes*/ ctx[2] && /*changes*/ ctx[2].size) return 0;
		return 1;
	}

	current_block_type_index_2 = select_block_type_2(ctx, -1);
	if_block2 = if_blocks_2[current_block_type_index_2] = if_block_creators_2[current_block_type_index_2](ctx);

	return {
		c() {
			section = element("section");
			div0 = element("div");
			h20 = element("h2");
			h20.textContent = "Added";
			t1 = space();
			if_block0.c();
			t2 = space();
			div1 = element("div");
			h21 = element("h2");
			h21.textContent = "Removed";
			t4 = space();
			if_block1.c();
			t5 = space();
			div2 = element("div");
			h22 = element("h2");
			h22.textContent = "Changed";
			t7 = space();
			if_block2.c();
			attr(h20, "class", "svelte-5tv68u");
			attr(div0, "class", "cards-wrapper svelte-5tv68u");
			attr(h21, "class", "svelte-5tv68u");
			attr(div1, "class", "cards-wrapper svelte-5tv68u");
			attr(h22, "class", "svelte-5tv68u");
			attr(div2, "class", "cards-wrapper svelte-5tv68u");
			attr(section, "class", "wrapper svelte-5tv68u");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, div0);
			append(div0, h20);
			append(div0, t1);
			if_blocks[current_block_type_index].m(div0, null);
			append(section, t2);
			append(section, div1);
			append(div1, h21);
			append(div1, t4);
			if_blocks_1[current_block_type_index_1].m(div1, null);
			append(section, t5);
			append(section, div2);
			append(div2, h22);
			append(div2, t7);
			if_blocks_2[current_block_type_index_2].m(div2, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if_block0.p(ctx, dirty);
			if_block1.p(ctx, dirty);
			if_block2.p(ctx, dirty);
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			if_blocks[current_block_type_index].d();
			if_blocks_1[current_block_type_index_1].d();
			if_blocks_2[current_block_type_index_2].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	
	let { schemas } = $$props;

	// SCRIPT
	const diffMaps = getDiff(...schemas);

	const additions = diffMaps.additions;
	const removals = diffMaps.removals;
	const changes = diffMaps.changes;

	$$self.$$set = $$props => {
		if ("schemas" in $$props) $$invalidate(3, schemas = $$props.schemas);
	};

	return [additions, removals, changes, schemas];
}

class Cards extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { schemas: 3 });
	}
}

export default Cards;